import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseClient';

const useCollection = (collectionName, orderBy = 'created_at', ascending = false) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from(collectionName)
      .select('*')
      .order(orderBy, { ascending });

    if (!error && data) {
      setItems(data);
    }
    setLoading(false);
  }, [collectionName, orderBy, ascending]);

  useEffect(() => {
    if (!collectionName) return;

    fetchData();

    const channelId = `realtime:${collectionName}-${Math.random().toString(36).substring(2, 9)}`;

    const channel = supabase
      .channel(channelId)
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: collectionName },
        () => {
          fetchData();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [collectionName, fetchData]);

  return { items, loading, refetch: fetchData };
};

export default useCollection;